import { Component } from '@theme/component';

/**
 * @typedef {Object} CountdownRefs
 * @property {HTMLElement} days
 * @property {HTMLElement} hours
 * @property {HTMLElement} minutes
 * @property {HTMLElement} seconds
 */

/** @extends {Component<CountdownRefs>} */
class PrivateSaleCountdown extends Component {
  /** @type {number | undefined} */
  #intervalId;

  connectedCallback() {
    super.connectedCallback();
    this.#tick();
    this.#intervalId = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.#intervalId !== undefined) {
      window.clearInterval(this.#intervalId);
      this.#intervalId = undefined;
    }
  }

  #tick() {
    const target = Date.parse(this.dataset.target ?? '');
    if (Number.isNaN(target)) return;

    const diff = target - Date.now();
    if (diff <= 0) {
      this.#write(0, 0, 0, 0);
      if (this.#intervalId !== undefined) {
        window.clearInterval(this.#intervalId);
        this.#intervalId = undefined;
      }
      window.location.reload();
      return;
    }

    const days = Math.floor(diff / 86_400_000);
    const hours = Math.floor((diff / 3_600_000) % 24);
    const minutes = Math.floor((diff / 60_000) % 60);
    const seconds = Math.floor((diff / 1000) % 60);
    this.#write(days, hours, minutes, seconds);
  }

  /**
   * @param {number} d
   * @param {number} h
   * @param {number} m
   * @param {number} s
   */
  #write(d, h, m, s) {
    const { days, hours, minutes, seconds } = this.refs;
    this.toggleAttribute('data-has-days', d > 0);
    if (days) days.textContent = String(d);
    if (hours) hours.textContent = String(h).padStart(2, '0');
    if (minutes) minutes.textContent = String(m).padStart(2, '0');
    if (seconds) seconds.textContent = String(s).padStart(2, '0');
  }
}

if (!customElements.get('private-sale-countdown')) {
  customElements.define('private-sale-countdown', PrivateSaleCountdown);
}
